var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 526 396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cdeeff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "css"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.18,13V27.32H258.13v3h22.92V63.38H241.54v-15H264.4V45.64h-23V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M329,13V27.32H305.84v3h22.92V63.39H289.31v-15H312V45.57H289.22V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M233.4,13V29.47H210.31v4.15c0,3.5.08,7,0,10.48-.05,1.68.5,2.17,2.15,2.15,6.1-.09,12.2,0,18.29,0h2.58V62.72H193.66V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.7,85.79l24,268,107.24,29.94L370.7,353.79l23.48-268ZM330.1,307.48l-67.6,19.23-67.4-18.23-4-52h33l2,26,36.4,9.9,36.6-9.9,4-43h-114l-3-33h120l3-33h-126l-3-33H344.91Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCss);
export default __webpack_public_path__ + "static/media/icon-css.affa707d34793a7591b305a614ade0d0.svg";
export { ForwardRef as ReactComponent };